export default "__VITE_ASSET__Da_wY_gt__"